import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import Box from '../../../Box/index.esm.js';
import { safeHtmlString } from '../../utils/functions.esm.js';

var ContentEditable = function ContentEditable(_ref) {
  var value = _ref.value,
      innerEditableRef = _ref.innerEditableRef,
      inputRef = _ref.inputRef,
      change = _ref.change,
      remove = _ref.remove,
      validator = _ref.validator,
      removeOnBackspace = _ref.removeOnBackspace,
      styleProps = _ref.styleProps;

  // Track if element has been removed from DOM
  var _useState = useState(false),
      removed = _useState[0],
      setRemoved = _useState[1]; // Save value before input is focused / user starts typing


  var _useState2 = useState(''),
      preFocusedValue = _useState2[0],
      setPreFocusedValue = _useState2[1];

  var getRef = function getRef() {
    return innerEditableRef.current;
  };

  var getValue = function getValue() {
    var ref = getRef();
    return ref ? ref.innerText : '';
  };

  var focusInputRef = function focusInputRef() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(function () {
    setPreFocusedValue(getValue());
  }, []);

  var onPaste = function onPaste(e) {
    // Cancel paste event
    e.preventDefault(); // Remove formatting from clipboard contents

    var text = e.clipboardData.getData('text/plain'); // Insert text manually from paste command

    document.execCommand('insertHTML', false, safeHtmlString(text));
  };

  var onFocus = function onFocus() {
    setPreFocusedValue(getValue());
  };

  var onBlur = function onBlur() {
    var ref = innerEditableRef.current;

    if (!removed && ref) {
      // On blur, if no content in tag, remove it
      if (ref.innerText === '') {
        remove();
        return;
      } // Validate input if needed


      if (validator) {
        var valid = validator(getValue()); // If invalidate, switch ref back to pre focused value

        if (!valid) {
          ref.innerText = preFocusedValue;
          return;
        }
      }

      change(ref.innerText);
    }
  };

  var onKeyDown = function onKeyDown(e) {
    // On enter, focus main tag input
    if (e.key === 'Enter') {
      e.preventDefault();
      focusInputRef();
      return;
    } // On backspace, if no content in ref, remove tag and focus main tag input


    var content = getValue();

    if (removeOnBackspace && e.key === 'Backspace' && content === '') {
      setRemoved(true);
      remove();
      focusInputRef();
    }
  };

  return React__default.createElement(Box, _extends({
    ref: innerEditableRef,
    contentEditable: true,
    onPaste: onPaste,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    dangerouslySetInnerHTML: {
      __html: safeHtmlString(value)
    }
  }, styleProps));
};

export default ContentEditable;
//# sourceMappingURL=index.esm.js.map
